import React, { useState, useCallback } from 'react';
import * as S from './style';
import { VideoPlayer } from '..';
import { publicUrlStr } from '../../utils';

import { SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export interface ILocalVideo {
  id: number;
  title: string;
  source: string;
  yt: boolean;
}

interface VideoSliderProps {
  title: React.ReactNode;
  videos: ILocalVideo[];
}

// Thumbnail with fallback for broken YouTube thumbnails
function VideoThumbnail({ vid }: { vid: ILocalVideo }) {
  const [thumbError, setThumbError] = useState(false);
  const thumbUrl = vid.yt
    ? `https://img.youtube.com/vi/${vid.source}/0.jpg`
    : `${publicUrlStr()}/videos/thumbnails/${vid.source}.jpg`;

  const handleImgError = useCallback(() => setThumbError(true), []);

  return (
    <>
      <S.VideoTile videoThumbUrl={thumbError ? undefined : thumbUrl} />
      {/* Hidden img to detect load errors for background-image */}
      <img
        src={thumbUrl}
        alt=""
        onError={handleImgError}
        style={{ display: 'none' }}
      />
    </>
  );
}

function VideoSlider({ title, videos }: VideoSliderProps) {
  const [selectedVideo, setSelectedVideo] = useState<ILocalVideo | null>(null);

  const handleClick = (video: ILocalVideo) => {
    setSelectedVideo(video);
  };

  const handleClosePlayer = () => {
    setSelectedVideo(null);
  };

  return (
    <S.SliderWrapper>
      <S.SliderTitle>{title}</S.SliderTitle>
      {videos.length === 0 ? (
        <S.NoMediaMessage>Sorry! No content available for this category</S.NoMediaMessage>
      ) : (
        <S.MySwiper
          modules={[Navigation, FreeMode]}
          navigation
          freeMode
          slidesPerView="auto"
          style={{ width: '97%' }}
        >
          {videos.map((vid) => (
            <SwiperSlide key={vid.id}>
              <S.VideoSliderItem onClick={() => handleClick(vid)}>
                <VideoThumbnail vid={vid} />
                <S.MediaTitle>{vid.title}</S.MediaTitle>
              </S.VideoSliderItem>
            </SwiperSlide>
          ))}
        </S.MySwiper>
      )}

      {selectedVideo && (
        <VideoPlayer
          isYt={selectedVideo.yt}
          videoSource={selectedVideo.source}
          onClose={handleClosePlayer}
        />
      )}
    </S.SliderWrapper>
  );
}

export default VideoSlider;
